import React, {useEffect, useRef, useState} from "react";
import {Button, Col, Form, Input, Modal, Row, Select} from "antd";
import {CloseIco, CommunalIcon, ModalCloseIco, RemoveIco} from "../../../../../../modules/CustomIcons";
// import {Scrollbar} from "smooth-scrollbar-react";
import SearchInput from "components/SearchInput";
import './GppModal.scss'
import {Scrollbar as BaseScrollbar} from "smooth-scrollbar/scrollbar";
import {Scrollbar} from "smooth-scrollbar-react";
import {gppProduct} from "../../../../../services/Transfers/GppTransfer";
import SelectField from "components/SelectField";
import SearchableColumn from "components/Table/ColumnSearch";
import {setSelectedOption} from "store/actions/salary";
import {useTranslation} from "react-i18next";
import {SearchOutlined} from "@ant-design/icons";

const data = [
    {
    key:1,
    title:"Kommunal",
    icon:<CommunalIcon/>,
        content:[
            {
                key:'Mida',
                title:'MIDA MMC',
                icon:<CommunalIcon/>
            },
            {
                key:'Azərişıq',
                title:'Azərişıq ASC',
                icon:<CommunalIcon/>
            },
            {
                key:'MMC',
                title:'MIDA MMC',
                icon:<CommunalIcon/>
            },
            {
                key:'ASC',
                title:'Azərişıq ASC',
                icon:<CommunalIcon/>
            }
        ]

}, {
        key:2,
        title:"Kommunal",
        icon:<CommunalIcon/>

    }, {
        key:3,
        title:"Kommunal",
        icon:<CommunalIcon/>

    }, {
        key:4,
        title:"Kommunal",
        icon:<CommunalIcon/>

    },
    {
        key:5,
        title:"Kommunal",
        icon:<CommunalIcon/>

    },
    {
        key:6,
        title:"Kommunal",
        icon:<CommunalIcon/>

    },
    {
        key:7,
        title:"Kommunal",
        icon:<CommunalIcon/>

    },
    {
        key:8,
        title:"Kommunal",
        icon:<CommunalIcon/>

    },
    {
        key:9,
        title:"Kommunal",
        icon:<CommunalIcon/>

    },
    {
        key:10,
        title:"Kommunal",
        icon:<CommunalIcon/>

    },
    {
        key:11,
        title:"Kommunal",
        icon:<CommunalIcon/>

    },
    {
        key:12,
        title:"Kommunal12",
        icon:<CommunalIcon/>

    },
]


const GppModal: React.FC<any> = (props) => {

    const {t} = useTranslation()
    const [filteredData,setFiltered] = useState({})
    const scrollbar = useRef<BaseScrollbar | null>(null)
    const [visible,setVisible]= useState(false)
    const [modalData,setModalData] = useState([])
    const [selectedCategoryId,setSelectedCategoryId] = useState()
    const language = localStorage.getItem("i18nextLng")
    const [noHover, setHover] = useState(null)
    const [dateFilterList, setDateFilterList] = useState<Array<any>>([]);
    const [noHover2, setHover2] = useState(null)
    const [form] = Form.useForm()
    const [teskilatList,setTeskilatList]= useState([])
    const [filteredValues, setFilteredValues] = useState(undefined)
    const [filteredValue, setFilteredValue] = useState(undefined)
    const [filteroption,setfilterOptions] = useState([])
    const [selectedOrg,setSelectedOrg]= useState(null)
    const [visibleFilter,setVisibleFilter]= useState(false)
    const selectInputRef = useRef();
    const [buttonClicked, setButtonClicked] = useState(0);

    const fetchData =async () =>{
        let temp_data=[]
        const data = await gppProduct(language)
        setModalData(data?.data)
        data?.data?.map((item)=>{
            item.paymentList?.map((row)=>{
                temp_data.push({
                   ...row,
                    'type':item.name
                })
            })
        })
        setTeskilatList(temp_data)
        setfilterOptions(data?.data)
    }

    useEffect( () => {
       if(props.visible){
           fetchData()
       }
        setFilteredValue(undefined);


        // setModalData(data)
        setVisible(props.visible)
    }, [props.visible]);
    const onTabChange = (e:any)=>{
        setFilteredValue(undefined)
        setSelectedOrg(null)
        // form.setFieldValue('searchBar','')
        setDateFilterList([])
        setSelectedCategoryId(e)
        // setButtonClicked(buttonClicked + 1);
       const newData =  modalData?.find((item)=>item?.categoryId===e)
        setFiltered(newData)

    }
    const onSearch=(e)=>{

        let newfilteredValues = filteredValues;
       if(e.target.value !== null || e.target.value!== undefined || e.target.value!== '') {
           setFilteredValue(e.target.value?.toLowerCase())
           if(e.target.value.length >=3){
               setVisibleFilter(true)
               newfilteredValues= e.target.value?.toLowerCase()
               setFilteredValues(newfilteredValues)

           }else{

               setVisibleFilter(false)
           }

       }else{
           setFilteredValue(undefined)
           setFilteredValues(undefined)
           setDateFilterList([])
       }


        if(filteroption && filteredValues!==null){
            let filteredData1

            filteredData1 = teskilatList?.filter((item)=>item.title.toLowerCase().includes(newfilteredValues?.toLowerCase()))


            setDateFilterList(filteredData1)
        }

    }

    const onFilterClick =(row:any)=>{
        setSelectedOrg(row)
        setVisibleFilter(false)
    }

    const onSelect = (e:any,data:any)=>{

        setVisible(false)
        form.setFieldsValue({"searchBar":''})
        props.selectedValue(e,data,filteredData?.name)
    }

    const handleRemove=()=>{
        setFilteredValue(undefined)
        form.setFieldsValue({"searchBar":''})
    }
    return (
        <div className='notificationWarningModal'>
            <Modal
                style={{top:60}}
                okText={props.okText}
                okButtonProps={{style: {background: '#015CD1'}}}
                title={props.modalTitle}
                centered
                open={visible}
                onOk={props.onOk}
                closeIcon={<ModalCloseIco />}
                onCancel={props.onCancel}
                okType='primary'
                width={960}
                className={props.className || 'gpp_modal'}
                cancelButtonProps={{ style: { display: 'none' } }}
                footer={false}
            >
                <div className={'column-header-gpp'} >

                   <Input
                        onChange={e=>onSearch(e)}
                        style={{
                            width: 645}}
                        form={form}
                        value={filteredValue}
                        name={'searchBar'}
                        placeholder={t("transfers.searchbyOrg")}
                        className={'gppsearchbar searchBar'}
                        suffix={
                        filteredValue !== undefined && filteredValue!== '' ?
                            <Button
                                // ghost
                                style={{border:"none"}}
                                className="custom-close-gpp"
                                onClick={()=>handleRemove()}
                                icon={<CloseIco />}
                            />:<Button
                               // ghost
                                style={{border:"none"}}
                               className=" search-icon"
                               icon={props.customIcon ? props.customIcon : <SearchOutlined />}
                           />
                        }
                   />

                    {/*<SearchableColumn*/}
                    {/*    showSearch={true}*/}
                    {/*    className={'gppsearchbar searchBar'}*/}
                    {/*    name={'searchBar'}*/}
                    {/*    form={form}*/}
                    {/*    filter={"searchfilter"}*/}
                    {/*    onChange={(event: any) =>*/}
                    {/*        onSearch(event)*/}
                    {/*    }*/}
                    {/*    allowClear={true}*/}
                    {/*    buttonClicked={buttonClicked}*/}
                    {/*    placeholder={t("transfers.searchbyOrg")}*/}
                    {/*/>*/}
                </div>
                <Row onClick={()=>setVisibleFilter(false)} className={'category'}>
                   <Col className={'flex'}>

                    <Col  span={7} style={{minWidth:300,padding:5,top:-56}} >
                       <ul style={{border:"1px solid #D9E3EC",borderRadius:4,marginRight:13}}>
                           {
                           modalData?.map((item,index:any)=>{
                               const isSelected= item.categoryId === selectedCategoryId
                               return (
                                   <li key={index} className={`categoryList ${noHover === index ? 'lightBlue' : ''} ${isSelected ? 'selected' : ''}`}
                                       onMouseLeave={() => setHover(null)}
                                       onMouseOver={() => setHover(index)}
                                       style={{padding:"10px 20px",alignItems:'center',display:"flex"}}
                                       onClick={()=>{onTabChange(item.categoryId,item)}}
                                   >

                                       {/*{item.icon}*/}
                                       <p  style={{marginLeft:10}}>{item?.name}</p>

                                   </li>
                               )
                           })
                       }
                       </ul>

                    </Col>
                       <>
                           <Scrollbar
                           ref={scrollbar}
                           alwaysShowTracks={true}
                       >
                           <Col onClick={()=>setVisibleFilter(false)} className={'content'} >


                               { dateFilterList?.length == 0  ? '' :
                                   ( visibleFilter ?
                                       <Scrollbar>
                                           <div className={'full flex direction_column autocomplete_box_gpp '} >
                                               <ul className={'full flex direction_column autocomplete_list scroll_y'} >
                                                   {
                                                       dateFilterList?.map((row, index) => {
                                                           return (
                                                               <li onClick={()=>onFilterClick(row)} >
                                                                   {row.title+ " " + `(${row.type})`}
                                                               </li>
                                                           )
                                                       })
                                                   }
                                               </ul>
                                           </div>
                                       </Scrollbar>
                                        :'')
                               }
                               <Col>
                                   <ul
                                       className={'content_list'}>
                                       { selectedOrg === null ?
                                           filteredData?.paymentList?.map((items,index)=>{

                                               return(
                                                   <li

                                                       onClick={()=>onSelect(items?.vendorId,items)}
                                                       onMouseLeave={() => setHover2(null)}
                                                       onMouseOver={() => setHover2(index)}
                                                       className={`filteredContent ${noHover2 === index ? 'lightBlue' : ''} `}
                                                   >
                                                       {/*{items.icon}*/}
                                                       <p style={{marginLeft:10}}>{items.title}</p>
                                                   </li>
                                               )
                                           }):
                                           <li
                                               onClick={()=>onSelect(selectedOrg?.vendorId,selectedOrg)}
                                               // onMouseLeave={() => setHover2(null)}
                                               // onMouseOver={() => setHover2(index)}
                                               className={`filteredContent`}
                                           >
                                               {/*{items.row.icon}*/}
                                               <p style={{marginLeft:10}}>{selectedOrg.title}</p>
                                           </li>


                                       }
                                   </ul>
                               </Col>

                           </Col> </Scrollbar>
                       </>

                   </Col>
                </Row>


            </Modal>
        </div>
    )
}

export default GppModal
